import { isValidPhone, isValidCNPJ, isValidCPF } from '@brazilian-utils/brazilian-utils'
import isValidCreditCard from 'card-validator'
import * as yup from 'yup'

export const schema = yup
  .object({
    fullName: yup
      .string()
      .required('Nome é obrigatorio!')
      .min(3, 'Nome e sobrenome muito curto')
      .matches(/(\w.+\s).+/gi, 'O nome deve conter o  sobrenome!'),
    email: yup.string().email().required('Email é obrigatório!'),
    mobile: yup
      .string()
      .required('Numero é obrigatório!')
      .transform((value) => value.replace(/\D/g, ''))
      .test('validatePhone', 'Celular inválido!', (value) => isValidPhone(value)),
    typeDocument: yup.string(),
    document: yup
      .string()
      .required('O CPF/CNPJ é obrigatório.')
      .transform((value) => value.replace(/\D/g, ''))
      .test(
        'validateDocument',
        'O CPF/CNPJ é inválido!',
        (value) => isValidCPF(value) || isValidCNPJ(value),
      ),
    cep: yup
      .string()
      .required('O cep é obrigatório.')
      .transform((value) => value.replace(/\D/g, '')),
    street: yup.string().required('Rua é obrigatorio!'),
    number: yup.string().required('Numero é obrigatorio!'),
    complement: yup.string(),
    neighborhood: yup.string().required('Bairro é obrigatorio!'),
    city: yup.string().required('Cidade é obrigatorio!'),
    state: yup.string().required('Estado é obrigatorio!'),
    cardNumber: yup
      .string()
      .required('Número do cartão é obrigatorio!')
      .transform((value) => value.replace(/\D/g, ''))
      .test(
        'validateCardNumber',
        'O número do cartão é invalido!',
        (value) => isValidCreditCard.number(value).isValid,
      ),
    cardHolder: yup
      .string()
      .required('Nome do titular é obrigatorio!')
      .min(5, 'Nome do titular muito curto')
      .matches(/(\w.+\s).+/gi, 'Nome do tituiar deve conter o  sobrenome!'),
    cardExpiration: yup
      .string()
      .required('Data de validade é obrigatorio!')
      .transform((value) => {
        const [month, year] = value.split('/')
        if (month && year && month.length === 2 && year.length === 2) {
          return new Date(+`20${year}`, +month - 1, 1).toISOString()
        }
        return value
      })
      .test(
        'validateCreditCardExpiration',
        'A data de validade é inválida!',
        (value) => new Date(value) >= new Date(),
      ),

    cardSecurityCode: yup
      .string()
      .required()
      .transform((value) => value.replace(/\D/g, ''))
      .min(3, 'O CVV possui entre 3 e 4 digítos!')
      .max(4, 'O CVV possui entre 3 e 4 digítos!'),
  })
  .required()

export const address = ['street', 'complement', 'neighborhood', 'city', 'state']

export type FieldValues = yup.InferType<typeof schema>
